package com.daytimegaming.ourdailyfinances.domain.plaid

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow

class PlaidItemsEventBus {
    private val _events = MutableSharedFlow<Unit>()
    val events: SharedFlow<Unit> = _events.asSharedFlow()

    private val _orderEvents = MutableSharedFlow<Unit>()
    val orderEvents: SharedFlow<Unit> = _orderEvents.asSharedFlow()

    suspend fun itemsChanged() = _events.emit(Unit)
    suspend fun orderChanged() = _orderEvents.emit(Unit)
}
